module.exports = __webpack_public_path__ + "c7a589c5118c0eef3ca4a1a93163dbb5.svg";